export default "__VITE_ASSET__4241c7e9__"